export default {
  black: '#000',
  darkgray: '#253237',
  white: '#fff',
  green: '#00f703',
  none: 'transparent',
};
